import React, { useState, useEffect } from "react";
import { Modal, ModalBody, Button } from "reactstrap";
import { useHistory } from "react-router-dom";
import "../assets/css/region-access.css";
import { store } from "../store/index";
import useLogout from "../hooks/useLogOut.js";

const InvalidRegionAccess = () => {
  const [isOpen, setIsOpen] = useState(false);
  const user_region = store.getState()?.user?.user_region;
  const history = useHistory();
  const { logout } = useLogout();
  useEffect(() => {
    const handleShowPopup = () => {
      setIsOpen(true);
    };
    window.addEventListener("showRegionPopup", handleShowPopup);
    return () => window.removeEventListener("showRegionPopup", handleShowPopup);
  }, []);

  const handleUpgrade = () => {
    setIsOpen(false);
    history.push("/admin/plans");
  };

  const handleLogout = () => {
    setIsOpen(false);
    logout();
    // history.push("/admin/logout");
  };

  return (
    <Modal
      isOpen={isOpen}
      backdrop="static"
      keyboard={false}
      className="region-access-modal"
      centered
    >
      <ModalBody>
        <h4>Region Access Restricted</h4>
        <p>
          Your subscription is only valid for use within {user_region}. It looks
          like you are trying to access the website from outside this region.
        </p>
        <p>
          If you believe this is a mistake, please contact support +61
          426230061.
          <br />
          To upgrade your plan and unlock global access.
        </p>
        <div
          className="region-access-buttons"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "16px",
            marginTop: "24px",
          }}
        >
          <Button
            color="primary"
            className="btn-upgrade"
            onClick={handleUpgrade}
          >
            Upgrade Plan
          </Button>
          <span style={{ fontWeight: 600, color: "#888" }}>or</span>
          <Button className="btn-logout" onClick={handleLogout}>
            Logout
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};
export default InvalidRegionAccess;
